// Importazioni necessarie
import Dashboard from "layouts/dashboard";
import Cases from "layouts/cases";
import AlarmType from "layouts/tables";
import Billing from "layouts/tables/UncodedAlarms";
import Profile from "layouts/profile";
import AccountAssignation from "layouts/tables/AccountAssignation";
import Store from "layouts/store";
import { I18n } from "@aws-amplify/core";  // Importa I18n
import TemplateBox from "components/TemplateBox";
import NotePatterns from "layouts/tables/NotePatterns";
import ClosingPattern from "layouts/tables/ClosingPatterns";
import EventHistory from "layouts/tables/EventHistory";
import UnrecognizedEmail from "layouts/tables/UnrecognizedEmail";
import LastEmails from "layouts/tables/LastEmails";
import EmailMapping from "layouts/tables/EmailMapping";
import CalendarFilter from "layouts/tables/CalendarFilter";
import ClosureRulesFilter from "layouts/tables/ClosureRulesFilter";
// Imposta la lingua in base alla selezione memorizzata in localStorage
const lang = localStorage.getItem("language");
if (lang) {
  I18n.setLanguage(lang);
}

// Rotte con I18n.get() per ottenere le traduzioni
const routes = [
  {
    type: "route",
    name: I18n.get("dashboard"),  // Traduzione del nome della rotta
    key: "dashboard",
    route: "/dashboard",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <Dashboard />,
  },
  {
    type: "route",
    name: I18n.get("alarms_type"),  // Traduzione del nome della rotta
    key: "alarmstype",
    route: "/settings",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <AlarmType />,
  },
  {
    type: "route",
    name: I18n.get("profile"),  // Traduzione del nome della rotta
    key: "profile",
    route: "/profile",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <Profile />,
  },
  {
    type: "route",
    name: I18n.get("billing"),  // Traduzione del nome della rotta
    key: "billing",
    route: "/settings/uncoded",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <Billing />,
  },
  {
    type: "route",
    name: I18n.get("assignation"),  // Traduzione del nome della rotta
    key: "assignation",
    route: "/settings/assignation",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <AccountAssignation />,
  },
  {
    type: "route",
    name: I18n.get("unrecognized emails"),  // Traduzione del nome della rotta
    key: "unrecognized",
    route: "/settings/unrecognized",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <UnrecognizedEmail />,
  },  
  {
    type: "route",
    name: I18n.get("last emails"),  // Traduzione del nome della rotta
    key: "emails",
    route: "/settings/emails",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <LastEmails />,
  },
  {
    type: "route",
    name: I18n.get("email mapping"),  // Traduzione del nome della rotta
    key: "map",
    route: "/settings/map",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <EmailMapping />,
  },
  {
    type: "route",
    name: I18n.get("calendar"),  // Traduzione del nome della rotta
    key: "calendar",
    route: "/settings/calendar",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <CalendarFilter />,
  },
   {
    type: "route",
    name: I18n.get("closure"),
    key: "closure",
    route: "/settings/closure",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <ClosureRulesFilter />,
  },
  {
    type: "route",
    name: I18n.get("close"),  // Traduzione del nome della rotta
    key: "close",
    route: "/settings/close",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <ClosingPattern />,
  },
  {
    type: "route",
    name: I18n.get("note"),  // Traduzione del nome della rotta
    key: "note",
    route: "/settings/note",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <NotePatterns />,
  },
  {
    type: "route",
    name: I18n.get("event"),  // Traduzione del nome della rotta
    key: "event",
    route: "/settings/event",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <EventHistory />,
  },
  {
    type: "route",
    name: I18n.get("cases"),  // Traduzione del nome della rotta
    key: "cases",
    route: "/cases",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <Cases />,
  },
  {
    type: "route",
    name: I18n.get("stores"),  // Traduzione del nome della rotta
    key: "stores",
    route: "/stores",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <Store />,
  },
];

export default routes;
